import script from "./learningProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./learningProducts.vue?vue&type=script&setup=true&lang=js"

import "./learningProducts.vue?vue&type=style&index=0&id=79e45948&lang=scss"

const __exports__ = script;

export default __exports__